module.exports = __webpack_public_path__ + "img/qt-04.93acad97.png";